// extracted by mini-css-extract-plugin
export default {"videoFrameContainer":"styles_videoFrameContainer__VIe5M","image":"styles_image__g0lhG","button":"styles_button__q6thH"};